import * as actionTypes from '../actions/actionTypes';
// import { deepCopy, updateObject } from '../../shared/utility';
import { updateObject } from '../../shared/utility';

const initialState = {
    token: null,
    userId: null,
    userName: null,
    apiVersion: null,
    modulePermissions: null,
    error: null,
    loading: false,
    authRedirectPath: '/admin'
};

const authStart = (state, action) => {
    return updateObject(state, {error: null, loading: true});
};

const authSuccess = (state, action) => {
    // console.log('auth_reducer.authSuccess email:', action.email);
    return updateObject(state, {
        token: action.token,
        userId: action.userId,
        userName: action.userName,
        modulePermissions: action.modulePermissions,
        error: null, 
        loading: false,
    });
};

const authFail = (state, action) => {
    return updateObject(state, {error: action.error, loading: false});
};

const authLogout = (state, action) => {
    // console.log('auth_reducer.authLogout email:', action.email);
    return updateObject( state, { token: null, userId: null } );
};

const setAuthRedirectPath = (state, action ) => {
    return updateObject( state, {authRedirectPath: action.path} );
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action);
        default: return state;
    }
};

export default reducer;